<div class="mat-elevation-z4">
  <mat-toolbar color="secondary" class="mat-elevation-z4">
    <div style="flex: 1 1 auto" class="fx-layout-column fx-layout-align-space-between-m fx-layout-align-stretch-x">
      <div class="fx-layout-row fx-layout-align-space-between-m">
        <!-- <button mat-icon-button (click)="toggleMenu()">
        <mat-icon title="Toggle menu">menu</mat-icon>
      </button> -->
      <div class="header-logo-container fx-layout-row">
        @if (!isAuthenticated) {
          <div><img src="/assets/images/logo.png" height="50" alt="Logo" class="header-logo"></div>
        }
        @if (isAuthenticated) {
          <a [routerLink]="['']" class="fx-layout-align-center-m fx-layout-align-center-x"><img src="/assets/images/logo.png" height="50" alt="Logo" class="header-logo"></a>
        }
        <div height="50" class="company-name">{{ currentCompanyName }}</div>
      </div>
      @if (isAuthenticated) {
        <div>
          <!-- wrapper div used to align username with mat icon -->
          <div class="UserButton fx-layout-align-center-m fx-layout-align-center-x">
            <div class="username">{{ loggedInFullName }}</div>
            <button mat-icon-button [matMenuTriggerFor]="appMenu">
              <mat-icon>account_circle</mat-icon>
            </button>
          </div>
          <mat-menu #appMenu="matMenu">
            <button [disabled]="currentCompanyCount <= 1" mat-menu-item (click)="switchCompany()">Switch Company</button>
            <button mat-menu-item (click)="twoFactor()">2FA Management</button>
            <button mat-menu-item (click)="resetPassword()">Reset Password</button>
            <button mat-menu-item (click)="logout()">Sign out</button>
          </mat-menu>
        </div>
      }
    </div>
    <div class="primaryBackgroundColor fx-layout-row fx-layout-align-space-between-m"></div>
  </div>
</mat-toolbar>
</div>
